var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TitlesComponent"}},[_c('center',[(_vm.title != null)?_c('h2',{staticClass:"titleGeneral"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._t("default"),_c('div',{staticClass:"underlinedTitle"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }